import { useEffect, useState } from 'react';
import useHostDataTrack from './useHostDataTrack';
export default function useHostDataTrackMsg() {
    const hostDataTrack = useHostDataTrack();
    const [msg, setMsg] = useState(String);
    useEffect(() => {
        let cb;
        if (hostDataTrack) {
            hostDataTrack.on('message', (e) => {
                setMsg(e);
            });
            cb = () => {
                hostDataTrack.off('message', setMsg);
            };
        }
        return cb;
    }, [hostDataTrack]);
    return msg;
}
//# sourceMappingURL=useHostDataTrackMsg.js.map